<template>
  <div>
    <div class="relative overflow-x-auto shadow-md sm:rounded-sm mt-5">
      <table class="w-full text-left rtl:text-right text-gray-700">
        <thead>
          <tr class="bg-gray-100">
            <th
              v-for="(header, index) in tableHeaders"
              :key="index"
              scope="col"
              class="px-6 py-3"
            >
              <div class="flex items-center">
                {{ header }}
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(stock, index) in stockItems"
            :key="index"
            class="border-b"
          >
            <td class="px-6 py-2">{{ stock.batch_no }}</td>
            <td class="px-6 py-2">{{ stock.inventory_item }}</td>
            <td class="px-6 py-2">{{ stock.initial_quantity }}</td>
            <td class="px-6 py-2">{{ stock.available_quantity }}</td>
            <td class="px-6 py-2">{{ stock.cost_per_unit }}</td>
            <td class="px-6 py-2">{{ stock.expiry_date }}</td>
            <td class="px-6 py-2">
              <button
                @click="viewInventoryItem()"
                class="bg-orange-400 hover:bg-orange-500 text-white px-4 py-1 rounded"
              >
                View Details
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="flex justify-center gap-4 mt-4">
      <button
        :disabled="currentPage === 1"
        class="flex items-center gap-2 px-6 py-3 font-bold text-center text-custom-blue align-middle transition-all rounded-lg select-none hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
        type="button"
        @click="currentPage--"
      >
        <svg
          class="w-6 h-6"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="m15 19-7-7 7-7"
          />
        </svg>
        Previous
      </button>
      <div class="flex items-center gap-2">
        <button
          v-for="page in paginationPages"
          :key="page"
          :class="[
            'relative h-10 max-h-[40px] w-10 max-w-[40px] select-none rounded-lg text-center align-middle font-medium transition-all',
            currentPage === page
              ? 'bg-custom-blue text-white shadow-md shadow-custom-blue/10 hover:shadow-lg hover:shadow-custom-blue/20'
              : 'text-custom-blue hover:bg-custom-blue/10 active:bg-custom-blue/20',
          ]"
          type="button"
          @click="currentPage = page"
        >
          <span
            class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
          >
            {{ page }}
          </span>
        </button>
      </div>
      <button
        :disabled="currentPage === paginationPages[paginationPages.length - 1]"
        class="flex items-center gap-2 px-6 py-3 font-bold text-center text-custom-blue align-middle transition-all rounded-lg select-none hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
        type="button"
        @click="currentPage++"
      >
        Next
        <svg
          class="w-6 h-6"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="m9 5 7 7-7 7"
          />
        </svg>
      </button>
    </div>
    <!-- Modal placeholder -->
    <InventoryQueueModal
      :show="showModal"
      :medicationDetails="selectedMedicationDetails"
      @close="closeDetailsModal"
    />
  </div>
</template>

<script>
// import axios from 'axios';
import InventoryQueueModal from "@/views/modals/InventoryQueueModal.vue";

export default {
  name: "StockQueueTab",
  components: {
    InventoryQueueModal,
  },
  data() {
    return {
      currentPage: 1,
      showModal: false,
      selectedMedicationDetails: null,
      tableHeaders: [
        "Batch No",
        "Inventory Item ",
        "Initial Quantity",
        "Available Quantity",
        "Cost Per Unit",
        "Expiry Date",
        "Action",
      ],
      stockItems: [
        {
          batch_no: 3444,
          inventory_item: "Actal Tums 100s",
          initial_quantity: 300,
          available_quantity: 200,
          cost_per_unit: 5000,
          expiry_date: "4/5/2024",
        },
        {
          batch_no: 3444,
          inventory_item: "Actal Tums 100s",
          initial_quantity: 300,
          available_quantity: 200,
          cost_per_unit: 5000,
          expiry_date: "4/5/2024",
        },
        {
          batch_no: 3444,
          inventory_item: "Actal Tums 100s",
          initial_quantity: 300,
          available_quantity: 200,
          cost_per_unit: 5000,
          expiry_date: "4/5/2024",
        },
      ],
      paginationPages: [1, 2, 3, 4, 5, "...", 11],
    };
  },
  mounted() {},
  methods: {
    viewInventoryItem() {
      this.$router.push({ name: "InventoryItemDetails" });
    },
  },
};
</script>

<style scoped>
/* Add any additional styles here if needed */
</style>
